// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to undo the CLOSE COUNTERS operation.
  </span>
</div>
<div class="alert alert--danger">
  This operation is not fully safe to do and should not be overused.
  Please use it only in emergency situations when an undo close counters is absolutely necessary
  and inform the client that they should pay special attention when closing counters.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branch:</td>
      <td>
        <select required
                ng-model="\$ctrl.command.branchId"
                ng-options="entry.id as entry.name for entry in \$ctrl.branches">
        </select>

      </td>
    </tr>
    <tr>
      <td>Date with closed counter:</td>
      <td>
        <date output-format="date"
          ng-model="\$ctrl.command.closedCounterDate"
          ng-required="true"></date>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button
      type="submit"
      class=" btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/undo-close-counters/undo-close-counters.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;